type QuizMode = 'practice' | 'exam';

export interface QuizViewModelInput {
  mode: QuizMode;
  currentIndex: number;
  totalQuestions: number;
  answeredCount: number;
  isLastQuestion: boolean;
  hasSelectedAnswer: boolean;
  showResult: boolean;
}

export interface QuizViewModel {
  modeLabel: string;
  answeredLabel: string;
  progressPercent: number;
  primaryActionLabel: string;
  secondaryActionLabel?: string;
}

export function buildQuizViewModel({
  mode,
  currentIndex,
  totalQuestions,
  answeredCount,
  isLastQuestion,
  hasSelectedAnswer,
  showResult,
}: QuizViewModelInput): QuizViewModel {
  const current = Math.min(currentIndex + 1, Math.max(totalQuestions, 1));
  const safeTotal = Math.max(totalQuestions, 1);
  const progressPercent =
    mode === 'practice'
      ? Math.round((Math.min(answeredCount, safeTotal) / safeTotal) * 100)
      : Math.round((current / safeTotal) * 100);

  const modeLabel = mode === 'exam' ? '模拟考试' : '专项训练';
  const primaryActionLabel = getPrimaryActionLabel({
    mode,
    isLastQuestion,
    hasSelectedAnswer,
    showResult,
  });

  return {
    modeLabel,
    answeredLabel:
      mode === 'practice'
        ? `已答 ${Math.min(answeredCount, safeTotal)} 题`
        : `已完成 ${Math.min(answeredCount, safeTotal)} 题`,
    progressPercent,
    primaryActionLabel,
    secondaryActionLabel: mode === 'exam' ? '交卷' : '结束本轮',
  };
}

function getPrimaryActionLabel({
  mode,
  isLastQuestion,
  hasSelectedAnswer,
  showResult,
}: {
  mode: QuizMode;
  isLastQuestion: boolean;
  hasSelectedAnswer: boolean;
  showResult: boolean;
}) {
  if (showResult) {
    return isLastQuestion ? '完成练习' : '下一题';
  }
  if (hasSelectedAnswer) {
    return mode === 'exam' ? (isLastQuestion ? '提交并交卷' : '提交并继续') : '提交本题';
  }
  return isLastQuestion ? '完成练习' : '跳过此题';
}
